import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, useParams } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider, useLang } from "./i18n/LanguageContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { FloatingButtons } from "./components/FinalCTA";
import { useTracking } from "./lib/useTracking";
import { usePricing } from "./lib/usePricing";
import Home from "./pages/Home";
import Booking from "./pages/Booking";
import Preise from "./pages/Preise";
import Routen from "./pages/Routen";
import Firmenkunden from "./pages/Firmenkunden";
import Reisebuero from "./pages/Reisebuero";
import Admin from "./pages/Admin";
import Ratgeber from "./pages/Ratgeber";
import Guide from "./pages/Guide";
import Article from "./pages/Article";
import ChildSeat from "./pages/ChildSeat";
import Topic from "./pages/Topic";
import PaymentResult from "./pages/PaymentResult";
import Landing from "./pages/Landing";
import { resolveAny } from "./data/seoData";

function SlugRouter() {
  const { slug } = useParams();
  return resolveAny(slug) ? <Landing /> : <Article />;
}

function LangHome({ code }) {
  const { lang, setLang } = useLang();
  useEffect(() => {
    if (lang !== code) setLang(code);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code]);
  return <Home />;
}

function Chrome({ children }) {
  const { pathname } = useLocation();
  const bare = pathname === "/admin";
  useTracking();
  usePricing();
  return (
    <>
      {!bare && <Navbar />}
      <main className="flex-1">{children}</main>
      {!bare && <Footer />}
      {!bare && <FloatingButtons />}
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen flex flex-col overflow-x-hidden">
      <LanguageProvider>
        <BrowserRouter>
          <Chrome>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/de" element={<LangHome code="de" />} />
              <Route path="/en" element={<LangHome code="en" />} />
              <Route path="/fr" element={<LangHome code="fr" />} />
              <Route path="/it" element={<LangHome code="it" />} />
              <Route path="/booking" element={<Booking />} />
              <Route path="/payment-result" element={<PaymentResult />} />
              <Route path="/preise" element={<Preise />} />
              <Route path="/ziele" element={<Routen />} />
              <Route path="/firmenkunden" element={<Firmenkunden />} />
              <Route path="/reisebuero" element={<Reisebuero />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/ratgeber" element={<Ratgeber />} />
              <Route path="/ratgeber/:slug" element={<Guide />} />
              <Route path="/kindersitze/:slug" element={<ChildSeat />} />
              <Route path="/flughafentransfer" element={<Topic />} />
              <Route path="/airporttaxi-zurich" element={<Topic />} />
              <Route path="/airport-transfer-zurich" element={<Topic />} />
              <Route path="/stadttransfer-zurich" element={<Topic />} />
              <Route path="/ski-transfer-zurich" element={<Topic />} />
              <Route path="/business-transfer-zurich" element={<Topic />} />
              <Route path="/gruppentransfer-zurich" element={<Topic />} />
              <Route path="/stundenservice-zurich" element={<Topic />} />
              <Route path="/kreuzfahrt-transfer-zurich" element={<Topic />} />
              <Route path="/kindersichere-fahrten-zurich" element={<Topic />} />
              <Route path="/:lang/:slug" element={<Landing />} />
              <Route path="/:slug" element={<SlugRouter />} />
            </Routes>
          </Chrome>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
